import { OrderFormat } from '@caresend/types';
import { buildMaybePartnerRoute } from '../../helpers/builders.js';
import { getRouter } from '../../helpers/initRouter.js';
import { OrderFlowRouteName } from './model.js';
import { getOrderFlowMaybeAsChildName } from './privateHelpers.js';

const orderFlowNewDraftOrderRoute = (locationData) => buildMaybePartnerRoute({
    ...locationData,
    path: '/edit-order',
    params: {
        ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
    },
});
const orderFlowNewDraftOrderFromOrderRoute = (orderID, locationData) => buildMaybePartnerRoute({
    ...locationData,
    path: `/re-order/${orderID}`,
});
const orderFlowEditDraftOrderRoute = (draftOrderID, locationData) => buildMaybePartnerRoute({ ...locationData, path: `/edit-order/${draftOrderID}` });
const orderFlowVisitOverviewRoute = (draftOrderID, locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: OrderFlowRouteName.ORDER_FLOW_VISIT_OVERVIEW,
    params: {
        draftOrderID,
    },
});
const orderFlowSwitchFormatRoute = (orderFormat, asChild, locationData) => {
    let name;
    switch (orderFormat) {
        case OrderFormat.CSV:
            name = getOrderFlowMaybeAsChildName(OrderFlowRouteName.ORDER_FLOW_BULK_UPLOAD, asChild);
            break;
        case OrderFormat.PDF:
            name = getOrderFlowMaybeAsChildName(OrderFlowRouteName.ORDER_FLOW_PDF_UPLOAD, asChild);
            break;
        case OrderFormat.MANUAL:
            name = getOrderFlowMaybeAsChildName(OrderFlowRouteName.ORDER_FLOW_MANUAL_INPUT, asChild);
            break;
    }
    return buildMaybePartnerRoute({
        ...locationData,
        name,
        params: {
            ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
            ...getRouter().currentRoute.params,
        },
    });
};

export { orderFlowEditDraftOrderRoute, orderFlowNewDraftOrderFromOrderRoute, orderFlowNewDraftOrderRoute, orderFlowSwitchFormatRoute, orderFlowVisitOverviewRoute };
